import { AmountSuperScript } from "components/design/AmountSuperScript";
import { Banner } from "components/DesignSystem/Banner/Banner";
import { Tag } from "components/DesignSystem/Tag/Tag";
import { formatDate } from "utils/formatDate";
import { formatNumber } from "utils/formatNumber";

export const ExchangeRateSummary = ({
  rate,
  currency,
  date,
  isCustom = false,
  totalAmount,
  usdEquivalent,
}: {
  rate?: number | null;
  currency: string;
  date?: string | null;
  isCustom?: boolean;
  totalAmount: number;
  usdEquivalent?: number | null;
}) => {
  const rateText = rate ? formatNumber(Number(rate)) : "...";

  const bannerDescription = isCustom
    ? `Exchange Rate: 1.00 USD = ${rateText} ${currency}`
    : `Exchange Rate (as of ${
        date ? formatDate(date) : "..."
      }): 1.00 USD = ${rateText} ${currency}`;

  return (
    <div className="t-flex t-flex-col t-gap-3">
      <Banner
        type="info"
        description={
          <div className="t-flex t-items-center t-gap-2">
            <span>{bannerDescription}</span>
            {isCustom && (
              <Tag tagType="white" icon={false} size="small" rounded bordered>
                Custom
              </Tag>
            )}
          </div>
        }
      />

      <div className="t-flex t-justify-between t-items-center">
        <span className="t-text-body-sm">Total</span>
        <span className="t-text-subtext">
          <AmountSuperScript amount={totalAmount} currencyCode={currency} />
        </span>
      </div>

      <div className="t-flex t-justify-between t-items-center">
        <span className="t-text-body-sm t-text-text-30">USD Equivalent</span>
        <span className="t-text-subtext">
          {usdEquivalent != null ? (
            <AmountSuperScript amount={usdEquivalent} />
          ) : (
            "..."
          )}
        </span>
      </div>
    </div>
  );
};
